import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Pipe({
  name: 'toFormGroup'
})
export class ToFormGroupPipe implements PipeTransform {
  transform(control: AbstractControl): UntypedFormGroup {
    return control as UntypedFormGroup;
  }
}
